import axios, { AxiosInstance } from 'axios';
import { v4 as uuidv4 } from 'uuid';

export declare type CardData = {
    cardNumber: string;
    month: string;
    year: string;
    cardCode?: string;
    zip?: string;
    fullName?: string;
};

export declare type ErrorMessage = {
    code: string;
    text: string;
};
export declare type DispatchDataResponse = {
    opaqueData: {
        dataDescriptor: string;
        dataValue: string;
    };
    messages: {
        resultCode: 'Ok' | 'Error';
        message: ErrorMessage[];
    };
};

class AuthorizeDotNetHook {
    private axiosInstance: AxiosInstance;

    constructor() {
        const baseUrl = import.meta.env.VITE_APP_AUTHORIZE_DOT_NET_RESOURCE || '';
        this.axiosInstance = axios.create({
            baseURL: baseUrl
        });
    }

    post(data: CardData): Promise<DispatchDataResponse> {
        const { month, year, cardNumber, cardCode, zip, fullName } = data;
        const merchantAuthentication = {
            name: import.meta.env.VITE_APP_AUTHORIZE_NET_LOGIN_ID,
            clientKey: import.meta.env.VITE_APP_AUTHORIZE_NET_CLIENT_KEY
        };
        const payload = {
            securePaymentContainerRequest: {
                merchantAuthentication,
                data: {
                    type: 'TOKEN',
                    id: uuidv4(),
                    token: {
                        cardNumber,
                        expirationDate: `${month}${year}`,
                        cardCode,
                        zip,
                        fullName
                    }
                }
            }
        };
        return this.axiosInstance
            .post('/request.api', payload, {
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8'
                }
            })
            .then(response => {
                if(!response?.data?.opaqueData) {
                    throw new Error('Failed to get payment token from Authorize.Net');
                }
                return response.data;
            })
            .catch(error => {
                throw error;
            });
    }
}

const authorizeNetInstance = new AuthorizeDotNetHook();
export default authorizeNetInstance;
